import {
    AORIGEM_CONTATO_AVULSOS,
    AORIGEM_CONTATO_CLIENTES,
    ASITUACAO_FOLLOWUP_ABERTO,
    ASITUACAO_FOLLOWUP_ENCERRADO
} from 'consts';
import {
    buildListParams,
    getListData,
    getTotalRecords,
    handleListDeleteIconMouseEnter,
    handleListIconMouseEnter,
    handleListIconMouseLeave,
    listStyles,
    loadStoredJson,
    removeStoredKeys,
    saveStoredValue
} from 'lib/listUtils';
import {
    Box,
    Button,
    Card,
    CardContent,
    Input,
    Paper,
    Table,
    TableBody,
    TableCell,
    TableHead,
    TablePagination,
    TableRow,
    Tooltip
} from '@material-ui/core';
import {
    BackspaceOutlined,
    DeleteForeverOutlined,
    EditTwoTone,
    Search,
    VisibilityOutlined
} from '@material-ui/icons';
import api from 'services/api';
import { Link } from 'react-router-dom';
import React, { Component } from 'react';
import { formatData } from 'lib/functions';
import { safeSetState } from 'lib/reactUtils';
import PerfectScrollbar from 'react-perfect-scrollbar';
import { ComboPadraoMultiple } from 'views/Components';
import { AlertInformation, DeleteConfirmationModal } from 'components';

/* Listas fixa - Origem */
const LISTA_ORIGENS = [
    {
        id: AORIGEM_CONTATO_AVULSOS,
        item: 'Contatos avulsos'
    },
    {
        id: AORIGEM_CONTATO_CLIENTES,
        item: 'Clientes'
    }
];

/* Listas fixa - Situação */
const LISTA_SITUACOES = [
    {
        id: ASITUACAO_FOLLOWUP_ABERTO,
        item: 'Em aberto'
    },
    {
        id: ASITUACAO_FOLLOWUP_ENCERRADO,
        item: 'Encerrado'
    }
];

class FollowUpList extends Component {
    state = {
        searchFilter: loadStoredJson('followupSearchFilter', {
            assunto: '',
            nomecontato: '',
            desccidade: '',
            proximofollowup: '',
            situacoes: [LISTA_SITUACOES[0]],
            origens: LISTA_ORIGENS
        }),
        followups: [],
        open: false,
        openAlert: false,
        messageAlert: '',
        selectedId: null,
        selectedDesc: null,
        totalItems: 0,
        page: Number(sessionStorage.getItem('followupPage')) || 0,
        rowsPerPage: Number(sessionStorage.getItem('followupRowsPerPage')) || 10
    };

    estilo = listStyles;

    _isMounted = false;

    handleIconMouseEnter = handleListIconMouseEnter;
    handleIconMouseLeave = handleListIconMouseLeave;
    handleDeleteIconMouseEnter = handleListDeleteIconMouseEnter;
    safeSetState = safeSetState;

    /* Carrega os dados iniciais da tela */
    async componentDidMount() {
        this._isMounted = true;
        this.loadFollowUps();
    };

    /* Paginação */
    componentDidUpdate(prevProps, prevState) {
        const { page, rowsPerPage, searchFilter } = this.state;

        // persiste os filtros e a paginação no sessionStorage
        if (prevState.searchFilter !== searchFilter) {
            saveStoredValue('followupSearchFilter', searchFilter);
        }

        if (prevState.page !== page) {
            saveStoredValue('followupPage', page);
        }

        if (prevState.rowsPerPage !== rowsPerPage) {
            saveStoredValue('followupRowsPerPage', rowsPerPage);
        }
    };

    /* Limpa os filtros e a paginação ao sair da tela */
    componentWillUnmount() {
        this._isMounted = false;

        removeStoredKeys([
            'followupSearchFilter',
            'followupPage',
            'followupRowsPerPage'
        ]);
    };

    /* Carrega os follow up */
    loadFollowUps = async () => {
        const { searchFilter, page, rowsPerPage } = this.state;

        const {
            assunto,
            desccidade,
            nomecontato,
            origens,
            proximofollowup,
            situacoes
        } = searchFilter;

        const codigoSituacoes = situacoes.map(item => item.id);
        const codigoOrigens = origens.map(item => item.id);

        const filtros = [
            {
                field: 'ASSUNTO',
                value: assunto,
                operator: '_like_'
            },
            {
                field: 'NOMECONTATO',
                value: nomecontato,
                operator: '_like_'
            },
            {
                field: 'DESCCIDADE',
                value: desccidade,
                operator: '_like_'
            },
            {
                field: 'PROXIMOFOLLOWUP',
                value: proximofollowup
            },
            {
                field: 'SITUACAO',
                value: codigoSituacoes.length ? codigoSituacoes.join(',') : '-1',
                operator: '_in_'
            },
            {
                field: 'ORIGEMCONTATO',
                value: codigoOrigens.length ? codigoOrigens.join(',') : '-1',
                operator: '_in_'
            }
        ];

        const params = buildListParams({
            page,
            rowsPerPage,
            filters: filtros
        });

        try {
            const response = await api.get('/followup' + params);

            this.safeSetState({
                followups: getListData(response),
                totalItems: getTotalRecords(response)
            });
        } catch (error) {
            console.error('Erro ao carregar os follows up:', error);

            this.safeSetState({
                followups: [],
                totalItems: 0
            });
        }
    };

    /* Muda a página */
    handleChangePage = (event, newPage) => {
        this.setState({ page: newPage }, this.loadFollowUps);
    };

    /* Muda a quantidade de retornos por página */
    handleChangeRowsPerPage = (event) => {
        this.setState({
            rowsPerPage: parseInt(event.target.value, 10),
            page: 0
        }, this.loadFollowUps);
    };

    /* Deleta o follow up */
    handleDelete = async (id) => {
        try {
            const response = await api.delete(`/followup/${id}`);

            // verifica se a exclusão foi bem-sucedida
            if (response.status === 200) {
                this.handleClose();
                this.loadFollowUps();
            }
        } catch (error) {
            this.handleClose();

            this.handleOpenAlert(
                error.response?.data?.error ||
                error.response?.data?.message ||
                'Erro ao excluir o follow up!'
            );
        }
    };

    /* Confirma a exclusão */
    handleConfirmDelete = () => {
        const { selectedId } = this.state;

        this.handleDelete(selectedId);
    };

    /* Abre a janela de confirmação para a exclusão */
    handleOpen = (codfollowup, assunto) => {
        this.setState({
            open: true,
            selectedId: codfollowup,
            selectedDesc: assunto
        });
    };

    /* Abre a janela de alerta com mensagem */
    handleOpenAlert = (message) => {
        this.setState({
            openAlert: true,
            messageAlert: message
        });
    };

    /* Fecha a janela de confirmação da exclusão */
    handleClose = () => {
        this.setState({
            open: false,
            selectedId: null,
            selectedDesc: ''
        });
    };

    /* Fecha a janela de mensagem alerta */
    handleCloseAlert = () => {
        this.setState({ openAlert: false });
    };

    /* Pesquisa os filtros na tela */
    onChangeSearch = (event) => {
        const { name, value } = event.target;

        const searchFilter = {
            ...this.state.searchFilter,
            [name]: (typeof value === 'string') ? value.toUpperCase() : value
        };

        this.setState({
            searchFilter,
            page: 0
        });
    };

    /* Pesquisa as situações */
    onChangeSituacoes = (selected) => {
        this.setState({
            searchFilter: {
                ...this.state.searchFilter,
                situacoes: selected
            },
            page: 0
        });
    };

    /* Pesquisa as origens */
    onChangeOrigens = (selected) => {
        this.setState({
            searchFilter: {
                ...this.state.searchFilter,
                origens: selected
            },
            page: 0
        });
    };

    /* Limpa os filtros da tela */
    limpaFiltros = () => {
        const searchFilter = {
            assunto: '',
            nomecontato: '',
            desccidade: '',
            proximofollowup: '',
            situacoes: [LISTA_SITUACOES[0]],
            origens: LISTA_ORIGENS
        };

        this.setState({
            searchFilter,
            page: 0
        }, this.loadFollowUps);
    };

    render() {
        const {
            followups,
            messageAlert,
            open,
            openAlert,
            page,
            rowsPerPage,
            searchFilter,
            selectedDesc,
            selectedId,
            totalItems
        } = this.state;

        const {
            actionIcon,
            addButton,
            filterPaper,
            iconGroup
        } = this.estilo;

        const basePath = this.props.match?.url || '';

        return (
            <div style={this.estilo}>
                <Paper
                    style={{
                        ...filterPaper,
                        width: '100%'
                    }}
                >
                    <Input
                        autoFocus
                        id="assunto"
                        name="assunto"
                        onChange={this.onChangeSearch}
                        placeholder="Assunto"
                        value={searchFilter.assunto}
                        style={{
                            flex: '0 1 220px',
                            minWidth: 220,
                            marginTop: 10
                        }}
                    />

                    <Input
                        id="nomecontato"
                        name="nomecontato"
                        onChange={this.onChangeSearch}
                        placeholder="Nome do contato"
                        value={searchFilter.nomecontato}
                        style={{
                            flex: '0 1 220px',
                            minWidth: 220,
                            marginTop: 10
                        }}
                    />

                    <Box
                        style={{
                            flex: '0 1 220px',
                            minWidth: 220,
                            marginBottom: 12,
                            marginTop: 6
                        }}
                    >
                        <ComboPadraoMultiple
                            options={searchFilter.origens || []}
                            label="Filtrar"
                            itens={LISTA_ORIGENS}
                            onSelectionChange={this.onChangeOrigens}
                        />
                    </Box>

                    <span style={iconGroup}>
                        <Tooltip title="Procurar">
                            <Search
                                onClick={this.loadFollowUps}
                                onMouseEnter={this.handleIconMouseEnter}
                                onMouseLeave={this.handleIconMouseLeave}
                                style={actionIcon}
                            />
                        </Tooltip>

                        <Tooltip title="Limpar">
                            <BackspaceOutlined
                                onClick={this.limpaFiltros}
                                onMouseEnter={this.handleIconMouseEnter}
                                onMouseLeave={this.handleIconMouseLeave}
                                style={actionIcon}
                            />
                        </Tooltip>
                    </span>

                    <div style={{ flex: 1 }} />

                    <Button
                        component={Link}
                        to={`${basePath}/novo`}
                        variant="contained"
                        color="primary"
                        style={addButton}
                    >
                        Novo
                    </Button>
                </Paper>

                <br />

                <Paper
                    style={{
                        ...filterPaper,
                        width: '100%'
                    }}
                >
                    <Box
                        style={{
                            flex: '0 1 220px',
                            minWidth: 220,
                            marginBottom: 12,
                            marginTop: 6
                        }}
                    >
                        <ComboPadraoMultiple
                            options={searchFilter.situacoes || []}
                            label="Situação"
                            itens={LISTA_SITUACOES}
                            onSelectionChange={this.onChangeSituacoes}
                        />
                    </Box>

                    <Input
                        id="desccidade"
                        name="desccidade"
                        onChange={this.onChangeSearch}
                        placeholder="Cidade"
                        value={searchFilter.desccidade}
                        style={{
                            flex: '0 1 220px',
                            minWidth: 220,
                            marginTop: 10
                        }}
                    />

                    <Input
                        id="proximofollowup"
                        name="proximofollowup"
                        type="date"
                        onChange={this.onChangeSearch}
                        value={searchFilter.proximofollowup}
                        style={{
                            flex: '0 1 180px',
                            minWidth: 180,
                            marginTop: 10
                        }}
                    />
                </Paper>

                <br />

                <Card>
                    <CardContent>
                        <PerfectScrollbar>
                            <div>
                                <Table>
                                    <TableHead>
                                        <TableRow>
                                            <TableCell align="center">Contato</TableCell>

                                            <TableCell align="center">Assunto</TableCell>

                                            <TableCell align="center">Próximo follow up</TableCell>

                                            <TableCell align="center">Ações</TableCell>
                                        </TableRow>
                                    </TableHead>

                                    <TableBody>
                                        {followups.length === 0 && (
                                            <TableRow>
                                                <TableCell
                                                    align="center"
                                                    colSpan={4}
                                                >
                                                    Nenhum follow up encontrado
                                                </TableCell>
                                            </TableRow>
                                        )}

                                        {followups.map(followup => {
                                            const isEncerrado = followup.situacao === ASITUACAO_FOLLOWUP_ENCERRADO;
                                            const estiloSituacao = isEncerrado ? { color: 'green' } : {};

                                            return (
                                                <TableRow
                                                    hover
                                                    key={followup.codfollowup}
                                                >
                                                    <TableCell
                                                        align="center"
                                                        style={estiloSituacao}
                                                    >
                                                        {followup.nomecontato}
                                                    </TableCell>

                                                    <TableCell
                                                        align="center"
                                                        style={estiloSituacao}
                                                    >
                                                        {followup.assunto}
                                                    </TableCell>

                                                    <TableCell
                                                        align="center"
                                                        style={estiloSituacao}
                                                    >
                                                        {formatData(followup.proximofollowup)}
                                                    </TableCell>

                                                    <TableCell align="center">
                                                        <span style={iconGroup}>
                                                            <Tooltip title="Editar">
                                                                <Link to={`${basePath}/${followup.codfollowup}`}>
                                                                    <EditTwoTone
                                                                        onMouseEnter={this.handleIconMouseEnter}
                                                                        onMouseLeave={this.handleIconMouseLeave}
                                                                        style={actionIcon}
                                                                    />
                                                                </Link>
                                                            </Tooltip>

                                                            <Tooltip title="Visualizar">
                                                                <Link to={`${basePath}/${followup.codfollowup}/view`}>
                                                                    <VisibilityOutlined
                                                                        onMouseEnter={this.handleIconMouseEnter}
                                                                        onMouseLeave={this.handleIconMouseLeave}
                                                                        style={actionIcon}
                                                                    />
                                                                </Link>
                                                            </Tooltip>

                                                            <Tooltip title="Excluir">
                                                                <DeleteForeverOutlined
                                                                    onClick={() => this.handleOpen(
                                                                        followup.codfollowup,
                                                                        followup.assunto
                                                                    )}
                                                                    onMouseEnter={this.handleDeleteIconMouseEnter}
                                                                    onMouseLeave={this.handleIconMouseLeave}
                                                                    style={actionIcon}
                                                                />
                                                            </Tooltip>
                                                        </span>
                                                    </TableCell>
                                                </TableRow>
                                            );
                                        })}
                                    </TableBody>
                                </Table>
                            </div>
                        </PerfectScrollbar>

                        <TablePagination
                            component="div"
                            count={totalItems}
                            onPageChange={this.handleChangePage}
                            onRowsPerPageChange={this.handleChangeRowsPerPage}
                            page={page}
                            rowsPerPage={rowsPerPage}
                            rowsPerPageOptions={[10, 50, 100, 200]}
                            labelRowsPerPage="Registros por página"
                        />
                    </CardContent>
                </Card>

                <DeleteConfirmationModal
                    open={open}
                    itemId={selectedId}
                    message={`Confirma exclusão do follow up ${selectedDesc || ''} [${selectedId}]?`}
                    handleClose={this.handleClose}
                    handleDelete={this.handleConfirmDelete}
                />

                <AlertInformation
                    open={openAlert}
                    message={messageAlert}
                    handleClose={this.handleCloseAlert}
                />
            </div>
        );
    }
};

export default FollowUpList;